import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl font-heading font-bold text-primary-500">
              丫丫影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={cat.key === 'all' ? '/' : `/category/${cat.key}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  (cat.key === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.key}`
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950'
                }`}
              >
                {cat.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="w-48 pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3">
            <div className="relative mb-3">
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="w-full pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.key}
                  to={cat.key === 'all' ? '/' : `/category/${cat.key}`}
                  className={`px-3 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                    (cat.key === 'all' && location.pathname === '/') ||
                    location.pathname === `/category/${cat.key}`
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-foreground-700'
                  }`}
                >
                  {cat.label}
                </Link>
              ))}
            </div>
            <Link
              to="/about"
              className="block mt-3 text-sm text-foreground-600 hover:text-primary-500 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}